import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToCTA = () => {
    const ctaSection = document.getElementById('cta-section');
    ctaSection?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-cream py-12 md:py-20 px-6" data-id="element-121">
      <div className="max-w-6xl mx-auto" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-123">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-warm-brown mb-4 leading-tight" data-id="element-124">
            Logra que tu bebé se duerma en 7 minutos
          </h1>
          <p className="font-serif text-xl md:text-2xl text-warm-brown/80 mb-8" data-id="element-125">
            (Sin dejarlo llorar y sin estrés)
          </p>
          <p className="text-lg md:text-xl text-warm-brown/90 max-w-3xl mx-auto leading-relaxed" data-id="element-126">
            El Método de Micro-conexión Sensorial diseñado para mamás agotadas
            que necesitan recuperar su sueño hoy mismo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-12 flex justify-center" data-id="element-127">
          <img src="https://cdn.magicpatterns.com/uploads/w5nR1GA62D9v6eXBzG9o9y/heylloyd-image-1774987264685.png" alt="Terapia de Sueño 7-Min - Bebé durmiendo pacíficamente" className="rounded-2xl shadow-2xl max-w-full md:max-w-2xl" data-id="element-128" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-129">
          <button onClick={scrollToCTA} className="bg-terracotta hover:bg-terracotta/90 text-white font-semibold text-lg px-12 py-5 rounded-full shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 mb-3" data-id="element-130">
            QUIERO EL MÉTODO 7-MIN AHORA
          </button>
          <p className="text-sm text-warm-brown/70" data-id="element-131">
            Acceso inmediato tras la compra. 100% Seguro.
          </p>
        </motion.div>
      </div>
    </section>;
}